const ADD_PLUS_LENGTH = 10;
const ADD_PLUS_ICON_WIDTH = 2;
const UNISIZE = 1;
const SIZES_PER_ROW_MOBILE = 6;
const SIZES_PER_ROW_DESKTOP = 8;
const ONE_SIZE = 'One Size';

const EVENTS = {
  COLOR_SWATCH_CLICK: 'colorSwatchClick',
  OPEN_SIZE_SELECTOR: 'openSizeSelector',
  CLICK_SIZE_SELECTOR: 'clickSizeSelector',
  UPSELL: 'upsell',
  UPSELL_ATC: 'upsell_addToCart',
  UPSELL_VIEW: 'upsell_view',
};

export {
  ADD_PLUS_LENGTH,
  ADD_PLUS_ICON_WIDTH,
  UNISIZE,
  SIZES_PER_ROW_MOBILE,
  SIZES_PER_ROW_DESKTOP,
  ONE_SIZE,
  EVENTS,
};
